export const splitRange = (rangeStart, rangeEnd, numIntervals) => {
  const intervalSize = (rangeEnd - rangeStart) / numIntervals;
  const intervals = [];

  for (let i = 0; i < numIntervals; i += 1) {
      const start = rangeStart + i * intervalSize;
      const end = start + intervalSize;
      if (i === 0) {
        intervals.push([start, end]);
      } else {
        intervals.push([start, end]);
      }
  }
  
  return intervals;
};
